/* src/app/shared/components/ag-toggle-switch/ag-toggle-switch.component.scss */
.switch {
  position: relative;
  display: inline-block;
  width: 56px;
  height: 32px;
  margin-right: 30px;
  cursor: pointer;
}
.switch.large {
  width: 72px;
  height: 40px;
}
.no-margin {
  margin: 0 !important;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f1f1f1;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.toggle-image {
  height: 12px;
  width: 12px;
  position: absolute;
  transition: transform 0.3s;
  transform: translate(31px, 8px);
  filter: brightness(0) saturate(100%) invert(87.5%);
}
.switch.large .toggle-image {
  height: 20px;
  width: 20px;
  transform: translate(40px, 10px);
}
.slider:before {
  position: absolute;
  content: "";
  height: 28px;
  width: 28px;
  left: 2px;
  bottom: 2px;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.switch.large .slider:before {
  height: 32px;
  width: 32px;
  left: 4px;
  bottom: 4px;
}
.switch.large .slider.round:before {
  height: 32px;
  width: 32px;
  left: 4px;
  bottom: 4px;
}
input:checked + .slider {
  background-color: #4aba96;
}
input:checked + .slider .line {
  background-color: #333333;
  -webkit-transform: translateX(23px);
  -ms-transform: translateX(23px);
  transform: translateX(23px);
}
input:checked + .slider.round.disabled {
  background-color: #f1f1f1;
}
input:checked + .slider:before {
  -webkit-transform: translateX(23px);
  -ms-transform: translateX(23px);
  transform: translateX(23px);
}
.switch.large input:checked + .slider:before {
  transform: translateX(32px);
}
input:checked + .slider .toggle-image {
  -webkit-transform: translate(8px, 8px);
  -ms-transform: translate(8px, 8px);
  transform: translate(8px, 8px);
  filter: brightness(0) invert(1);
}
.switch.large input:checked + .slider .toggle-image {
  transform: translate(10px, 10px);
}
.slider.round {
  border-radius: 432px;
}
.slider.round.disabled {
  cursor: not-allowed;
}
.slider.round.disabled:before {
  cursor: not-allowed;
  background-color: #f1f1f1;
}
.slider.round:before {
  border-radius: 432px;
}
.outerSection {
  display: flex;
  flex-direction: column;
  padding-right: 20px;
}
.toggleTitle {
  padding-right: 10px;
  margin-bottom: 10px;
  font-size: small;
  align-items: center;
}
.vatInput {
  position: relative;
}
.errorVatMessage {
  position: relative;
  margin-top: 5px;
  font-size: 10px;
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  color: red;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
/*# sourceMappingURL=ag-toggle-switch.component.css.map */
